// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  urlApi: 'https://api-pxy.denario.com.co/api/',
  URLDCARD: 'https://dcard-api-dev-bhg9anasa5b2awgd.eastus2-01.azurewebsites.net/api/',
  urlApikmlk: 'http://localhost:4370/api/',
  urlApi2: 'https://api-miviaje.denariotest.com.co/api/',
  Authorization: 'AutDenarioPro2021',
  AuthorizationCoorp: 'AutDenarioCoorp2021',
  AuthorizationAuth: 'AutDenarioPro2021',
  suclkectdL: 'http://localhost:4370',
  suclkect: 'https://api-pxy.denariotest.com.co',
  urlApisandbox: 'https://sandbox.denariotest.com.co/api/',
  suclkectSandbox: 'https://sandbox.denariotest.com.co',
  MIVIAJEAPIKEY: 'DenarioApiKey 3fa85f64-5717-4562-b3fc-2c963f66afa6',
  wanderlustUrl: 'https://wanderlus-adminpanel-prod-aad2g6dggfgsesey.eastus2-01.azurewebsites.net/api',
  wanderlustBearer: 'oesZZmHNycbhBXjBoVQi9YXi5M3hMdXm6gEHUWHE154e8f72',
  DCARDAPIKEY: 'c7f3a9d2-4b6e-4f1a-9c82-8e6d9f1b3a54_f8A2kPqR9mZL',
  urlApiPqr: 'https://api-pqr-produccion-dxfkf9dwdahybfd5.eastus2-01.azurewebsites.net/',
  apiKeyPqr: 'tu-api-key-segura'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.